import { Equal } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { m } from '@/lib/paraglide/messages'

interface Props {
    expected: number
    onFill: (value: number) => void
    disabled?: boolean
}

/**
 * QuickFillButton — nút "[=]" bên cạnh input Kiểm thực tế. Bấm → counted_qty
 * = expected_qty (variance = 0). Shortcut cho nhân viên đã đếm đúng số.
 */
export function QuickFillButton({ expected, onFill, disabled }: Props) {
    return (
        <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={() => onFill(expected)}
            disabled={disabled}
            title={m.stocktake_quick_fill_title()}
            className="shrink-0 h-11 w-11"
        >
            <Equal className="size-4" />
        </Button>
    )
}
